<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_vii"></a><a id="cont"></a></p>
<h2 class="h2a"><strong>Contents</strong></h2>
<p class="tocfront"><a class="nounder" href="#/xhtml/for#for"><strong><em>Foreword</em></strong></a><br/>Marie-Louise Mallet</p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch01#ch01"><strong>1 The Animal That Therefore I Am (More to Follow)</strong></a></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample"><strong>2 “But as for me, who am I (following)?”</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><strong>3 And Say the Animal Responded?</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample"><strong>4 “I don’t know why we are doing this”</strong></span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/notes#notes" title="Link target outside of Sample"><strong><em>Notes</em></strong></span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?4367559b